// /**
//  * parcel - Add
//  */

// React
import React, {useContext, useEffect, useState} from 'react';

// UI
import {makeStyles, Theme, createStyles} from '@material-ui/core/styles';

// Icon
import {
  mdiKey,
  mdiNumeric,
  mdiAccountOutline,
  mdiPackageVariant,
  mdiHomeSearchOutline,
  mdiHomeCityOutline, mdiStateMachine,
} from '@mdi/js';





// helpers'
import {
  removeEmptyValueObject,
} from '../../../utils/helpers';
import AuthContext from '../../../authContext';
import clsx from 'clsx';
import RenderFilter, {Filter} from '../../../utils/listDaynamicFilter';

type Props = {
  getInventoryItems: (filters: any) => void;
};

type Inputs = {
  count: number;
  product: string;
  categoryName: string;
  productCode: number;
  variant: string;
  unitCost: string;
  variantCode: number;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    margin: {
      // margin: theme.spacing(1),
    },
    filterBox: {
      backgroundColor: '#fff',
      width: '100%',
      display: 'block',
      borderRadius: '0  0 4px  4px',
      boxSizing: 'border-box',
    },
    filterOpen: {
      display: 'block',
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      // width: '25ch',
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      // marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '8px',
      marginTop: '21px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

const token = localStorage.getItem('token') || '';

export default function Add(props: Props) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const [filters, setFilters] = useState([] as Filter[]);
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 30,
  } as any);

  useEffect(() => {
    if (Object.keys(filtersValues).length > 2)
      props.getInventoryItems(filtersValues);

    setupFilters();
  }, [filtersValues]);

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'partnerName.contains',
        label: 'نام شرکت',
        icon: mdiAccountOutline,
      },
      {
        type: 'input',
        id: 'productCode.contains',
        label: 'کد کالا',
        icon: mdiNumeric,
      },
      {
        type: 'input',
        id: 'productName.contains',
        label: 'نام کالا',
        icon: mdiPackageVariant,
      },
      {
        type: 'input',
        id: 'variantCode.contains',
        label: 'کد تنوع کالا',
        icon: mdiPackageVariant,
      },
      {
        type: 'input',
        id: 'skuId.equals',
        label: 'شناسه تنوع کالا',
        icon: mdiKey,
      },
      {
        type: 'input',
        id: 'sellerCode.contains',
        label: 'کد فروشنده',
        icon: mdiHomeSearchOutline,
      },
      {
        type: 'input',
        id: 'providerCode.contains',
        label: 'کد تامین کننده',
        icon: mdiHomeCityOutline,
      },
      {
        type: 'checkbox',
        id: 'status.in',
        label: 'وضعیت',
        icon: mdiStateMachine,
        data: [
          'NOT_REGISTERED',
          'REGISTERED',
          'LOCATED',
          'NOT_LOCATED',
          'UNLOADED',
          'DELETED_BY_OPERATOR',
        ],
        translateType: 'InventoryItemStatus',
      },
    ]);
  };

  return (
    <>
      <div>
        <div
          className={clsx(classes.filterBox, {
            [classes.filterOpen]: true,
          })}
        >
          <RenderFilter
            filters={filters}
            onFilter={(filtervalues: any) => {
              setFiltersValues({
                ...removeEmptyValueObject(filtervalues),
                page: 0,
                size: 10000,
              });
            }}
          />
        </div>
      </div>
    </>
  );
}
